import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class Subject extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_subcode : null,
			_subname : null,
			_message : '',
			value : '',
			alertClass :'',
			_redirect : false,
			posts: [],
			isedit : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	onClick(e){
		
		document.getElementById("subform").reset();
	}
	
	/** set value to react select **/
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}
	onUpdateSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('subject/updatesub',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Subject Updated Successfully!..',
					alertClass:'alert alert-success',
					isedit : false
				});
				document.getElementById("subform").reset();
				this.getdata();
				this.getsubjectcode();
			}
			else{
		
				this.setState({
					_message:'Error',
					alertClass:'alert alert-danger'
				});
				document.getElementById("subform").reset();
				this.getdata();
				this.getsubjectcode();
			}
		});
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state._subcode && this.state._subname){
			
			PostData('subject/addsub',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Subject Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
					this.getdata();
					this.getsubjectcode();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("subform").reset();
					this.getdata();
					this.getsubjectcode();
				}
			});
		
		}
	
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
            $("#showLoader").show();			
			PostData('subject/deletesub',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Subject Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
					this.getsubjectcode();
				}
				else{
			
					alert('Subject was already assigned in Timetable / Reportcard');
				}
			});
		}
	}
	
	onAdd(){
		this.setState({isedit: false,idd : ''});
	}

	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({isedit: true});
		this.getsubjectbyid();
	}
	
	componentWillMount() {
		 
		this.getdata();
		this.getsubjectcode();
	}

	getsubjectbyid(){
		$("#showLoader").show();
		GetData('subject/getsubbyid/'+this.state.idd).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					_subcode : responseJson[0]['subcode'],
					_subname : responseJson[0]['subject'],
					_prefix : responseJson[0]['prefix']
				});
			}
		});
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('subject/getsub').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Subject Code **/
	getsubjectcode(){
		
		GetData('subject/getsubcode').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					_subcode : responseJson
				});
			}
		});
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/academic/subject/subjectupdate/' + this.state.idd} />);

	}
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				 {this.state.isedit == true ? 
					<Col md="5">
					<Card>
					<form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onUpdateSubmit} >
						<CardHeader>
							<strong>Edit Subject</strong>
							<Button type="button" size="sm" color="info" style={{float : 'right'}} onClick={this.onAdd.bind(this)}><i className="fa fa-plus"></i> Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							<Col md="12">
								<FormGroup>
								<Label htmlFor="name">Subject Code <span className="text-danger">*</span></Label>
								<Input type="text" name="_subcode" required onChange={this.onChange} value={this.state._subcode} disabled  />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								<Label htmlFor="name">Subject Name <span className="text-danger">*</span></Label>
								<Input type="text" name="_subname" onChange={this.onChange} value={this.state._subname} required />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								<Label htmlFor="name">Prefix <span className="text-danger">*</span></Label>
								<Input type="text" name="_prefix" required onChange={this.onChange} value={this.state._prefix}  />
								</FormGroup>
							</Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					</form>
					</Card>
				  </Col>: 
				  <Col md="5">
					<Card>
					  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Subject</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Subject Code <span className="text-danger">*</span></Label>
								  <Input type="text" name="_subcode" required onChange={this.onChange} value={this.state._subcode} disabled  />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Subject Name <span className="text-danger">*</span></Label>
								  <Input type="text" name="_subname" onChange={this.onChange} required />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Prefix <span className="text-danger">*</span></Label>
								  <Input type="text" name="_prefix" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				}
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Sub Code</th>
								<th>Prefix</th>
								<th>Subject</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map((item,i) =>
							 
								<tr key = {i}>
									<td>{i+1}</td>
									<td>{item.subcode}</td>
									<td>{item.prefix}</td>
									<td>{item.subject}</td>
									<td>
									<button name="removesub" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit" ><i className="fa fa-edit"></i></button>&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} data-toggle="tooltip" data-placement="top" title="Delete" ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							)}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Subject;


// WEBPACK FOOTER //
// ./src/subject/Subject/Subject.js